import { jsx as _jsx } from "react/jsx-runtime";
import { ShoppingCartFillIcon } from '@yonderland/andes-icons';
import { ButtonAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const MiniPDPMultiCTA = ({ amount, handleAddToBasket }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsx(ButtonAlpha, { fullWidth: true, theme: "branded", state: !amount ? 'disabled' : undefined, text: !amount
            ? t('product:product.look.no.items')
            : amount === 1
                ? t('product:product.look.add.item')
                : t('product:product.look.add.items', {
                    amount,
                }), iconLeft: {
            source: ShoppingCartFillIcon,
            size: 'sm',
        }, onClick: handleAddToBasket }));
};
